<template>
  <div style="height: 100%;">
    <Spin v-if="spinShow">{{$t('loading')}}</Spin>
    <div v-else style="height: 100%;">
      <div class="pbr-index-top-pane-curly" v-if='listDataByPageSize && listDataByPageSize.length > 0'>
        <div class="pbr-index-right-top-list">
          <ul>
            <li v-for="(item,index) in listDataByPageSize"
                ref="items"
                :key="index"
                :class="{ 'pbr-index-active':index==current}" @click="gotoDetail(item)">
              <el-tooltip :content="item.title"
                          placement="left"
                          :disabled="hiddenTooltip">
            <span class="pbr-list-curly-title"
                  @mouseover="titleMouseOver">
              {{ item.title }}
            </span>
              </el-tooltip>
            </li>
          </ul>
        </div>
        <div class="curly"
             :style="{'--curlyRadius': curlyRadius,'--curlyCursorPointY': curlyCursorPointY}">
          <div></div>
        </div>
        <div class="pbr-index-right-top-list-detail" v-if="listDataByPageSize && listDataByPageSize.length > 0"
             @click="gotoDetail(listDataByPageSize[current])">
          <ul>
            <li v-for="(column,index) in renderColumns"
                :key="index" :title="listDataByPageSize[current][column.field] | fieldFilter">{{ column.label }}:
              {{ listDataByPageSize[current][column.field] | fieldFilter(column.label,self) }}
            </li>
          </ul>
        </div>
      </div>
      <Empty v-else></Empty>
    </div>
  </div>


</template>

<script>
export default {
  name: 'pbrProjectListCurly',
  props: {
    list: {
      type: Array,
      //   required: true
      default: () => {
        return []
      }
    },
    pageSize: {
      type: Number,
      default: 5
    },
    columns: {
      type: Array,
      default () {
        let that = this
        return [
          {label: that.$t('label.home.date'), field: 'signDate'},
          {label: that.$t('label.home.amount'), field: 'buildSign'},
          {label: that.$t('label.home.country'), field: 'countryName'},
          {label: that.$t('label.home.type'), field: 'typeName'},
          {label: that.$t('label.home.enterprise'), field: 'conBuildUnit'}
        ]
      }
    },
    url: {
      type: String,
      default: ''
    },
    method: {
      type: String,
      default: 'GET'
    },
    params: {
      Type: Object,
      default: () => {
        return {
          // params: {
          pageNo: 1, pageSize: 15
          // }
        }
      }
    },
    listKey: {
      type: String,
      default: 'list'
    }
  },
  data () {
    return {
      self: this,
      spinShow:true,
      renderColumns: this.columns,
      current: 0,
      curlyRadius: '8px',
      curlyCursorPointY: '0px',
      hiddenTooltip: true,
      listData: []
    }
  },
  computed: {
    listDataByPageSize () {
      return this.listData && this.listData.length ? this.listData.slice(0, this.pageSize) : []
    }
  },
  methods: {
    titleMouseOver (e) {
      let parentWidth = e.currentTarget.parentNode.offsetWidth
      let contentWidth = e.currentTarget.scrollWidth
      // 判断是否开启tooltip功能
      if (contentWidth > parentWidth) {
        this.hiddenTooltip = false
      } else {
        this.hiddenTooltip = true
      }
    },
    loadData () {
      let self = this
      self.spinShow = true;
      // this.$pbrAxios.get(self.url, self.params).
      this.$pbrApis.requestByUrl(this.url, self.params, this.method).then((res) => {
        if (res.code === 200) {
          console.log(self.url, res.result[self.listKey])
          self.spinShow = false;
          self.listData = res.result[self.listKey]
        } else {
          self.listData = []
          //this.$iMessage.error({content: `${this.url}`, duration: 5})
        }
      }).catch(error => {
        //this.$iMessage.error({content: `${this.url}`, duration: 5})
        self.listData = []
      })
    },
    gotoDetail (detail) {
      this.$router.push({
        name: 'pbrProjectDetail',
        params:  {...detail,category:detail.typeName},
        query: {
          key: detail.id
        }
      })
    }
  },
  mounted () {

  },
  updated () {
    let self = this

    self.$refs.items && self.$refs.items.forEach((li, index) => {
      li.addEventListener('mouseover', function (e) {
        let curlyCursorPointY = parseInt(window.getComputedStyle(li).height) * index + 'px'
        // document.documentElement.style.setProperty('--curlyCursorPointY', curlyCursorPointY)
        self.curlyCursorPointY = curlyCursorPointY
        self.current = index
      })
      // li.addEventListener('click', function (e) {
      //   self.$router.push({ name: 'pbrProjectDetail' })
      // })
    })
  },
  watch: {
    url: {
      handler (newV, oldV) {
        if (newV.trim().length > 0) {
          this.loadData()
        }
      },
      immediate: true
    }
  },
  filters: {
    format: function (value, that) {
      if (that.$moment(value).isValid()) {
        return that.$moment(value).format('yyyy-MM-DD')
      }
      return value
    },
    fieldFilter: (value, label, vue) => {
      if (value === '' || !value) {
        return '--'
      } else if (label && vue && label === vue.$t('label.home.date')) {
        return vue.$moment(value).isValid() ? vue.$moment(value).format('yyyy-MM-DD') : value
      } else {
        return value
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.pbr-index-top-pane-curly li {
  cursor: pointer;
}

.pbr-list-curly-title {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
